const eyeShow = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6823 9.07875C17.8868 9.33141 18 9.65966 18 10C18 10.3403 17.8868 10.6686 17.6823 10.9212C16.3875 12.475 13.4404 15.5 10 15.5C6.55961 15.5 3.61247 12.475 2.3177 10.9212C2.1132 10.6686 2 10.3403 2 10C2 9.65966 2.1132 9.33141 2.3177 9.07875C3.61247 7.525 6.55961 4.5 10 4.5C13.4404 4.5 16.3875 7.525 17.6823 9.07875Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99989 12.4443C11.362 12.4443 12.4661 11.3499 12.4661 9.99992C12.4661 8.64991 11.362 7.55551 9.99989 7.55551C8.63783 7.55551 7.53366 8.64991 7.53366 9.99992C7.53366 11.3499 8.63783 12.4443 9.99989 12.4443Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const pencil = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.84772 13.6432L1 15L2.35736 10.1542L11.2341 1.324C11.3344 1.22143 11.4542 1.13994 11.5865 1.0843C11.7188 1.02866 11.8608 1 12.0043 1C12.1478 1 12.2899 1.02866 12.4222 1.0843C12.5544 1.13994 12.6742 1.22143 12.7746 1.324L14.6813 3.24079C14.7823 3.3409 14.8625 3.46 14.9171 3.59122C14.9718 3.72245 15 3.8632 15 4.00536C15 4.14751 14.9718 4.28826 14.9171 4.41949C14.8625 4.55071 14.7823 4.66981 14.6813 4.76992L5.84772 13.6432Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const present = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="5.25"
      y="12.5"
      width="17"
      height="11"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect
      x="3.75"
      y="7.75"
      width="20"
      height="4.75"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 7.73141C13.75 6.46198 12.269 3.5 10.0475 3.5C6.4335 3.5 7.75 7.73141 9.47977 7.73141"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 7.73141C13.75 6.46198 15.231 3.5 17.4525 3.5C21.0665 3.5 19.75 7.73141 18.0202 7.73141"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.75 12.5V23.5" stroke="#1C1C1C" strokeWidth="2" />
  </svg>
);

const eyeHide = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8514 5.8454C7.07323 5.05144 8.489 4.46153 10.0001 4.46153C13.434 4.46153 16.3755 7.50773 17.6678 9.07236C17.8719 9.32679 17.9849 9.65734 17.9849 10.0001C17.9849 10.3428 17.8719 10.6733 17.6678 10.9278C16.9554 11.7902 15.742 13.1029 14.2212 14.1073M11.8463 15.255C11.2526 15.4346 10.6347 15.5386 10.0001 15.5386C6.56626 15.5386 3.62472 12.4924 2.33241 10.9278C2.1283 10.6733 2.01532 10.3428 2.01532 10.0001C2.01532 9.65734 2.1283 9.32679 2.33241 9.07236C2.74186 8.57664 3.31685 7.9322 4.0206 7.28303"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7406 11.7406C12.7019 10.7794 12.7019 9.2208 11.7406 8.25951C10.7793 7.29822 9.22072 7.29822 8.25943 8.25951"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18L2 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const search = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
);

const searchSpinner = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M20 4v5h-.582m0 0a8.001 8.001 0 00-15.356 2m15.356-2H15M4 20v-5h.581m0 0a8.003 8.003 0 0015.357-2M4.581 15H9"
    />
  </svg>
);

const plus = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
  </svg>
);

const plusRounded = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2009_4664)">
      <path
        d="M1 12H23"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 23L12 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2009_4664">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

const plusInCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle cx="10" cy="10" r="9.25" stroke="currentColor" strokeWidth="1.5" />
    <rect x="9.25" y="6" width="1.5" height="8" rx="0.75" fill="currentColor" />
    <rect
      x="6"
      y="10.75"
      width="1.5"
      height="8"
      rx="0.75"
      transform="rotate(-90 6 10.75)"
      fill="currentColor"
    />
  </svg>
);

const minus = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 13H19V11H5V13Z" fill="currentColor" />
  </svg>
);

const trash = (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 22.5H16C17.1046 22.5 18 21.6046 18 20.5V6.5H4V20.5C4 21.6046 4.89543 22.5 6 22.5Z"
      stroke="var(--color-danger)"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.5H21"
      stroke="var(--color-danger)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 6.5L7.46446 4.03554C9.41709 2.08291 12.5829 2.08291 14.5355 4.03553L17 6.5"
      stroke="var(--color-danger)"
      strokeWidth="2"
    />
    <path
      d="M9 10.5V18.5"
      stroke="var(--color-danger)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 10.5V18.5"
      stroke="var(--color-danger)"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const trashCurrentColor = (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 22.5H16C17.1046 22.5 18 21.6046 18 20.5V6.5H4V20.5C4 21.6046 4.89543 22.5 6 22.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.5H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 6.5L7.46446 4.03554C9.41709 2.08291 12.5829 2.08291 14.5355 4.03553L17 6.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9 10.5V18.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 10.5V18.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const trashDisabled = (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 22.5H16C17.1046 22.5 18 21.6046 18 20.5V6.5H4V20.5C4 21.6046 4.89543 22.5 6 22.5Z"
      stroke="#808080FF"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.5H21"
      stroke="#808080FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5 6.5L7.46446 4.03554C9.41709 2.08291 12.5829 2.08291 14.5355 4.03553L17 6.5"
      stroke="#808080FF"
      strokeWidth="2"
    />
    <path
      d="M9 10.5V18.5"
      stroke="#808080FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13 10.5V18.5"
      stroke="#808080FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const chat = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1539 9.29883C19.2348 9.29883 21.2305 10.126 22.7019 11.5983C24.1734 13.0706 25 15.0675 25 17.1497C25.0049 18.6951 24.5485 20.2067 23.6893 21.4908L25 25.0006L20.5877 24.2063C19.5266 24.7241 18.3623 24.9956 17.1818 25.0005C16.0012 25.0055 14.8347 24.7439 13.7692 24.2351C12.7038 23.7263 11.7668 22.9835 11.0281 22.062C10.2894 21.1405 9.76808 20.0641 9.50293 18.913C9.23777 17.7619 9.23565 16.5657 9.49671 15.4137C9.75776 14.2616 10.2753 13.1834 11.0107 12.2593C11.7461 11.3352 12.6804 10.589 13.7441 10.0764C14.8077 9.56385 15.9733 9.29805 17.1539 9.29883V9.29883Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2801 4.69865C17.0368 3.11567 15.3312 1.95998 13.4007 1.39249C11.4702 0.824998 9.41089 0.873946 7.50949 1.53252C5.60809 2.19109 3.95924 3.42651 2.79249 5.06677C1.62575 6.70703 0.999189 8.6705 1.00004 10.6838C0.994321 12.5976 1.56004 14.4694 2.62466 16.0594L1.00004 20.382L4.9139 19.68"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* Files */
const file = (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9962 17.4615C16.9962 17.8696 16.8334 18.2609 16.5436 18.5494C16.2539 18.8379 15.8609 19 15.4511 19H2.54511C2.13532 19 1.74232 18.8379 1.45255 18.5494C1.16279 18.2609 1 17.8696 1 17.4615V2.53846C1 2.13044 1.16279 1.73912 1.45255 1.4506C1.74232 1.16209 2.13532 1 2.54511 1H12L16.9962 6.38462V17.4615Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 1V7H17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 15H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.5 11H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.5 7H7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const pdf = (
  <svg
    width="34"
    height="46"
    viewBox="0 0 34 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 2C0 0.89543 0.895431 0 2 0H20V13C20 13.5523 20.4477 14 21 14H34V44C34 45.1046 33.1046 46 32 46H2C0.89543 46 0 45.1046 0 44V2Z"
      fill="currentColor"
    />
    <path d="M22 0L28 6L34 12H22V0Z" fill="currentColor" />
    <path
      d="M25.6135 25.9179C25.0338 25.2899 23.9227 25 22.3285 25C21.4589 25 20.5411 25.0966 19.6715 25.2415C19.0918 24.7101 18.6087 24.0821 18.1256 23.4541C17.7874 22.971 17.4493 22.4879 17.1594 21.9565C17.6425 20.6039 17.9324 19.1546 18.029 17.7053C18.029 16.401 17.4976 15 16.0483 15C15.5652 15 15.0821 15.2899 14.8406 15.7246C14.2126 16.7874 14.4541 18.9614 15.4686 21.2319C15.1304 22.2464 14.744 23.2609 14.3092 24.372C13.9227 25.3382 13.4879 26.256 12.9565 27.1256C11.4589 27.7053 8.31884 29.1546 8.02899 30.7488C7.93237 31.2319 8.07729 31.715 8.46377 32.0048C8.80193 32.2947 9.28502 32.4879 9.76812 32.4396C11.6522 32.4396 13.5362 29.8309 14.8406 27.5604C15.5652 27.3188 16.2899 27.0773 17.0628 26.8841C17.8841 26.6908 18.657 26.4976 19.3816 26.3527C21.4106 28.0918 23.1981 28.3816 24.0676 28.3816C25.2754 28.3816 25.7585 27.8502 25.9034 27.4155C26.0966 26.8841 26 26.3043 25.6135 25.9179ZM24.3092 26.8357C24.2609 27.1739 23.8744 27.4155 23.3913 27.4155C23.2464 27.4155 23.1014 27.4155 22.9565 27.3672C21.9903 27.1256 21.0725 26.6425 20.2995 26.0145C20.9275 25.9179 21.6039 25.8696 22.2319 25.8696C22.6667 25.8696 23.1014 25.9179 23.5362 25.9662C23.971 26.0628 24.4541 26.256 24.3092 26.8357ZM15.6618 16.1594C15.7585 16.0145 15.9034 15.9179 16.0966 15.8696C16.5797 15.8696 16.6763 16.401 16.6763 16.8841C16.628 17.9952 16.4348 19.058 16.0966 20.1208C15.2754 18.0435 15.372 16.6425 15.6618 16.1594ZM18.3672 25.4348C17.8357 25.5314 17.3043 25.6763 16.7729 25.8213C16.3865 25.9179 16 26.0628 15.5652 26.1594C15.7585 25.7246 15.9517 25.2899 16.1449 24.9034C16.3865 24.372 16.5797 23.8406 16.7729 23.3092C16.9662 23.599 17.1111 23.8406 17.3043 24.0821C17.6425 24.5652 18.029 25 18.3672 25.4348ZM12.5217 28.2367C11.314 30.1691 10.1063 31.4251 9.42995 31.4251C9.33333 31.4251 9.18841 31.3768 9.1401 31.3285C8.99517 31.2319 8.94686 31.0386 8.99517 30.8937C9.09179 30.1691 10.4928 29.1546 12.5217 28.2367Z"
      fill="white"
    />
    <path
      d="M23.1716 42.14H21.6816V35H25.7716V36.24H23.1716V38.08H25.5916V39.32H23.1716V42.14Z"
      fill="white"
    />
    <path
      d="M20.1993 38.5C20.1993 39.3 20.046 39.97 19.7393 40.51C19.4326 41.05 18.986 41.4567 18.3993 41.73C17.8193 42.0033 17.1193 42.14 16.2993 42.14H14.2793V35H16.5193C17.266 35 17.9126 35.1333 18.4593 35.4C19.0126 35.6667 19.4393 36.06 19.7393 36.58C20.046 37.0933 20.1993 37.7333 20.1993 38.5ZM18.6293 38.54C18.6293 38.0133 18.5526 37.58 18.3993 37.24C18.246 36.9 18.016 36.65 17.7093 36.49C17.4093 36.3233 17.0393 36.24 16.5993 36.24H15.7893V40.89H16.4393C17.1793 40.89 17.7293 40.6933 18.0893 40.3C18.4493 39.9067 18.6293 39.32 18.6293 38.54Z"
      fill="white"
    />
    <path
      d="M10.28 35C11.2 35 11.87 35.2 12.29 35.6C12.7167 35.9933 12.93 36.5367 12.93 37.23C12.93 37.5433 12.8833 37.8433 12.79 38.13C12.6967 38.41 12.54 38.6633 12.32 38.89C12.1067 39.11 11.8233 39.2833 11.47 39.41C11.1167 39.5367 10.68 39.6 10.16 39.6H9.51V42.14H8V35H10.28ZM10.2 36.24H9.51V38.36H10.01C10.2967 38.36 10.5433 38.3233 10.75 38.25C10.9567 38.1767 11.1167 38.06 11.23 37.9C11.3433 37.74 11.4 37.5333 11.4 37.28C11.4 36.9267 11.3033 36.6667 11.11 36.5C10.9167 36.3267 10.6133 36.24 10.2 36.24Z"
      fill="white"
    />
  </svg>
);

const doc = (
  <svg
    width="34"
    height="46"
    viewBox="0 0 34 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 2C0 0.89543 0.895431 0 2 0H20V13C20 13.5523 20.4477 14 21 14H34V44C34 45.1046 33.1046 46 32 46H2C0.89543 46 0 45.1046 0 44V2Z"
      fill="currentColor"
    />
    <path d="M22 0L28 6L34 12H22V0Z" fill="currentColor" />
    <path
      d="M9 39L14.6071 28.5634L9.51842 19H13.3929L16.6808 25.4256L19.9004 19H23.734L18.6453 28.7135L24.2524 39H20.2551L16.6126 32.0832L12.97 39H9Z"
      fill="white"
    />
  </svg>
);

const spinner = (
  <svg
    aria-hidden="true"
    className="mr-8 h-16 w-16 animate-spin fill-primary text-secondary-300"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
);

const logOut = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7351 13.8288V16.0169C12.7351 16.307 12.6198 16.5853 12.4146 16.7905C12.2095 16.9956 11.9312 17.1109 11.6411 17.1109H3.98293C3.69278 17.1109 3.41451 16.9956 3.20935 16.7905C3.00418 16.5853 2.88892 16.307 2.88892 16.0169V3.98269C2.88892 3.69254 3.00418 3.41427 3.20935 3.2091C3.41451 3.00393 3.69278 2.88867 3.98293 2.88867H11.6411C11.9312 2.88867 12.2095 3.00393 12.4146 3.2091C12.6198 3.41427 12.7351 3.69254 12.7351 3.98269V6.17072"
      stroke="#1C1C1C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.453 10H17.1111"
      stroke="#1C1C1C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9231 7.8125L17.1111 10.0005L14.9231 12.1886"
      stroke="#1C1C1C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const pageSpinner = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 24 24"
  >
    <g>
      <rect width="2" height="5" x="11" y="1" fill="#002859" opacity=".14" />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".29"
        transform="rotate(30 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".43"
        transform="rotate(60 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".57"
        transform="rotate(90 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".71"
        transform="rotate(120 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".86"
        transform="rotate(150 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        transform="rotate(180 12 12)"
      />
      <animateTransform
        attributeName="transform"
        calcMode="discrete"
        dur="0.75s"
        repeatCount="indefinite"
        type="rotate"
        values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
      />
    </g>
  </svg>
);

const loadingSpinner = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
  >
    <g>
      <rect width="2" height="5" x="11" y="1" fill="#002859" opacity=".14" />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".29"
        transform="rotate(30 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".43"
        transform="rotate(60 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".57"
        transform="rotate(90 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".71"
        transform="rotate(120 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        opacity=".86"
        transform="rotate(150 12 12)"
      />
      <rect
        width="2"
        height="5"
        x="11"
        y="1"
        fill="#002859"
        transform="rotate(180 12 12)"
      />
      <animateTransform
        attributeName="transform"
        calcMode="discrete"
        dur="0.75s"
        repeatCount="indefinite"
        type="rotate"
        values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
      />
    </g>
  </svg>
);

/* Arrows */
const chevronUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="0" fill="#f48b09">
      <animate
        id="IconifyId191041c97d874f23e135"
        fill="freeze"
        attributeName="r"
        begin="0;IconifyId191041c97d874f23e137.end"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="0;11"
      />
      <animate
        fill="freeze"
        attributeName="opacity"
        begin="0;IconifyId191041c97d874f23e137.end"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="1;0"
      />
    </circle>
    <circle cx="12" cy="12" r="0" fill="#f48b09">
      <animate
        id="IconifyId191041c97d874f23e136"
        fill="freeze"
        attributeName="r"
        begin="IconifyId191041c97d874f23e135.begin+0.2s"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="0;11"
      />
      <animate
        fill="freeze"
        attributeName="opacity"
        begin="IconifyId191041c97d874f23e135.begin+0.2s"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="1;0"
      />
    </circle>
    <circle cx="12" cy="12" r="0" fill="#f48b09">
      <animate
        id="IconifyId191041c97d874f23e137"
        fill="freeze"
        attributeName="r"
        begin="IconifyId191041c97d874f23e135.begin+0.4s"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="0;11"
      />
      <animate
        fill="freeze"
        attributeName="opacity"
        begin="IconifyId191041c97d874f23e135.begin+0.4s"
        calcMode="spline"
        dur="1.2s"
        keySplines=".52,.6,.25,.99"
        values="1;0"
      />
    </circle>
  </svg>
);

const chevronDown = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7L10 13L16 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const arrowLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
    />
  </svg>
);

/* Alerts */
const danger = (
  <svg
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="var(--color-danger)"
  >
    <path d="M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"></path>
  </svg>
);

const info = (
  <svg
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="var(--color-primary-300)"
  >
    <path d="M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"></path>
  </svg>
);

const bell = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6484 22L13.4252 22.3902"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0546 13.1044C19.2616 11.6316 18.875 10.1368 17.9799 8.94892C17.0848 7.76107 15.7545 6.97744 14.2816 6.77044C12.8087 6.56344 11.3139 6.95002 10.1261 7.84513C8.9382 8.74025 8.15458 10.0706 7.94758 11.5435L7.26465 16.4028C7.18702 16.9551 6.89316 17.454 6.44772 17.7896C6.00227 18.1253 5.44173 18.2703 4.8894 18.1926L20.1615 20.339C19.6092 20.2614 19.1103 19.9675 18.7747 19.5221C18.439 19.0766 18.294 18.5161 18.3716 17.9638L19.0546 13.1044Z"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.79975 10.8766C4.98623 9.55519 5.48442 8.29709 6.25318 7.20624C7.02194 6.11538 8.0392 5.22308 9.22094 4.60304"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.551 13.4133C22.7359 12.0916 22.6038 10.7449 22.1655 9.48444C21.7272 8.22394 20.9953 7.08581 20.0303 6.16406"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const infoNoOutline = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 15.5V11.5"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.75 7.5V7.4999"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="11.75" cy="11.5" r="10" stroke="#1C1C1C" strokeWidth="2" />
  </svg>
);

const success = (
  <svg
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="var(--color-success)"
  >
    <path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"></path>
  </svg>
);

/* Contact  */
const address = (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 11.6364C23 18.7273 12 27 12 27C12 27 1 18.7273 1 11.6364C1 5.84309 6.00866 1 12 1C17.9913 1 23 5.84309 23 11.6364Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9997 15.4208C14.0247 15.4208 15.6663 13.7799 15.6663 11.7558C15.6663 9.7317 14.0247 8.09082 11.9997 8.09082C9.97463 8.09082 8.33301 9.7317 8.33301 11.7558C8.33301 13.7799 9.97463 15.4208 11.9997 15.4208Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const phone = (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.03478 23.1384C7.99478 23.8103 6.75549 24.1032 5.52527 23.9676C4.29506 23.8321 3.14895 23.2765 2.27967 22.3942L1.51972 21.65C1.18655 21.3087 1 20.8503 1 20.373C1 19.8956 1.18655 19.4373 1.51972 19.096L4.74528 15.8993C5.08321 15.5667 5.53806 15.3803 6.01186 15.3803C6.48567 15.3803 6.94052 15.5667 7.27845 15.8993C7.61923 16.233 8.07689 16.4198 8.55347 16.4198C9.03006 16.4198 9.48772 16.233 9.8285 15.8993L14.8948 10.8252C15.0638 10.6584 15.1981 10.4596 15.2897 10.2403C15.3813 10.0211 15.4284 9.78583 15.4284 9.54818C15.4284 9.31053 15.3813 9.07525 15.2897 8.85602C15.1981 8.63679 15.0638 8.438 14.8948 8.27119C14.5627 7.93274 14.3766 7.47719 14.3766 7.00266C14.3766 6.52812 14.5627 6.07258 14.8948 5.73413L18.1035 2.52052C18.4443 2.18683 18.902 2 19.3785 2C19.8551 2 20.3128 2.18683 20.6536 2.52052L21.3966 3.28163C22.2776 4.15226 22.8324 5.30012 22.9677 6.53223C23.103 7.76434 22.8106 9.00554 22.1397 10.0471C18.6438 15.2071 14.1958 19.6505 9.03478 23.1384Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const email = (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3077 4H2.69231C1.75767 4 1 4.76751 1 5.71429V20.2857C1 21.2325 1.75767 22 2.69231 22H21.3077C22.2423 22 23 21.2325 23 20.2857V5.71429C23 4.76751 22.2423 4 21.3077 4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.14307L10.9169 12.1846C11.221 12.3655 11.6042 12.4645 12 12.4645C12.3958 12.4645 12.779 12.3655 13.0831 12.1846L23 6.14307"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* Social */
const facebook = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M0 27.6923V2.30769C0 1.69565 0.243131 1.10868 0.675907 0.675907C1.10868 0.243131 1.69565 0 2.30769 0H27.6923C28.3043 0 28.8913 0.243131 29.3241 0.675907C29.7569 1.10868 30 1.69565 30 2.30769V27.6923C30 28.3043 29.7569 28.8913 29.3241 29.3241C28.8913 29.7569 28.3043 30 27.6923 30H20.7692V19.0615H22.4077C22.781 19.0615 23.1391 18.9132 23.4031 18.6492C23.6671 18.3852 23.8154 18.0272 23.8154 17.6538V15.8769C23.8154 15.6921 23.779 15.509 23.7082 15.3382C23.6375 15.1674 23.5338 15.0122 23.4031 14.8815C23.2724 14.7508 23.1172 14.6471 22.9464 14.5764C22.7756 14.5056 22.5926 14.4692 22.4077 14.4692H20.8615V12.3C20.8615 10.3615 21.7385 10.3615 22.6154 10.3615H23.7462C23.9319 10.3692 24.117 10.336 24.2885 10.2642C24.46 10.1924 24.6136 10.0838 24.7385 9.94615C24.8726 9.81848 24.9787 9.66437 25.0502 9.49357C25.1217 9.32276 25.157 9.13898 25.1538 8.95385V7.24615C25.16 7.05824 25.1291 6.87095 25.0628 6.695C24.9965 6.51905 24.8962 6.35788 24.7676 6.22072C24.6391 6.08355 24.4847 5.97308 24.3134 5.89561C24.1421 5.81814 23.9572 5.77519 23.7692 5.76923H21.1154C20.341 5.74012 19.5696 5.87945 18.8543 6.17759C18.1391 6.47574 17.4971 6.92559 16.9727 7.49608C16.4483 8.06657 16.0539 8.7441 15.8169 9.48187C15.58 10.2196 15.5059 11.0001 15.6 11.7692V14.4692H14.1231C13.9363 14.4662 13.7507 14.5003 13.5773 14.5697C13.4038 14.6391 13.2459 14.7423 13.1127 14.8733C12.9796 15.0043 12.8738 15.1605 12.8016 15.3328C12.7294 15.5051 12.6923 15.6901 12.6923 15.8769V17.6538C12.6923 17.8407 12.7294 18.0256 12.8016 18.1979C12.8738 18.3702 12.9796 18.5265 13.1127 18.6575C13.2459 18.7885 13.4038 18.8917 13.5773 18.9611C13.7507 19.0305 13.9363 19.0646 14.1231 19.0615H15.6V30H2.30769C1.69565 30 1.10868 29.7569 0.675907 29.3241C0.243131 28.8913 0 28.3043 0 27.6923Z"
      fill="currentColor"
    />
  </svg>
);

const twitter = (
  <svg
    width="35"
    height="30"
    viewBox="0 0 35 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6317 0.288128C24.9097 -0.555441 28.939 0.689714 31.2464 3.35904H34.4727C34.6448 3.35904 34.8048 3.44754 34.8962 3.59332C34.9877 3.73909 34.9978 3.92166 34.9229 4.07661L32.0078 10.1082C32.8636 16.6936 30.318 22.9687 25.1878 26.6496C20.0124 30.3628 12.2952 31.3764 2.97148 27.5568C2.62258 27.4279 2.3211 27.1958 2.10739 26.8913C1.89155 26.5836 1.77572 26.217 1.77572 25.8413C1.77572 25.4655 1.89155 25.0989 2.10739 24.7913C2.32322 24.4837 2.62857 24.25 2.98188 24.1219C2.99493 24.1172 3.00818 24.113 3.02158 24.1094C5.0192 23.5683 6.90281 22.6784 8.58612 21.4831C5.6042 20.038 3.16927 17.6535 1.66505 14.6855C0.0363605 11.472 -0.39453 7.78478 0.448689 4.28353C0.480818 3.9509 0.603579 3.63314 0.803971 3.36497C1.01331 3.08482 1.29859 2.87054 1.62597 2.74744C1.95334 2.62433 2.30914 2.59752 2.65127 2.67017C2.99322 2.74279 3.30727 2.91173 3.55622 3.1571C7.41037 6.94137 10.8222 8.54399 13.2435 9.20798C14.4559 9.54046 15.4251 9.63902 16.0836 9.65592C16.2739 9.6608 16.4383 9.65887 16.5752 9.65377C16.2179 7.01285 16.5902 4.93378 17.4784 3.38258C18.4287 1.72293 19.9375 0.724085 21.6317 0.288128Z"
      fill="currentColor"
    />
  </svg>
);

const linkedin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0C0.895431 0 0 0.89543 0 2V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V2C30 0.895431 29.1046 0 28 0H2ZM8.87394 5.74159C8.87874 6.35335 8.64038 6.94242 8.21037 7.38151C7.78036 7.82061 7.19322 8.07447 6.57581 8.08825C5.95969 8.06586 5.3758 7.80984 4.94481 7.3731C4.51382 6.93637 4.26866 6.35229 4.26001 5.74159C4.28679 5.14658 4.54096 4.58392 4.97099 4.16768C5.40101 3.75143 5.97472 3.51274 6.57581 3.5C7.17515 3.51298 7.74684 3.75226 8.17401 4.16892C8.60117 4.58558 8.85155 5.14814 8.87394 5.74159ZM4.5075 12.2562C4.5075 11.0748 5.17236 11.0898 6.14545 11.1116C6.28308 11.1147 6.42687 11.1179 6.57581 11.1179C6.72499 11.1179 6.86872 11.1147 7.00606 11.1116C7.97544 11.0897 8.62645 11.0751 8.62645 12.2562V25.3905C8.62645 26.547 8.00554 26.5235 7.0963 26.4891L7.09597 26.4891C6.93138 26.4829 6.75733 26.4763 6.57581 26.4763C6.3945 26.4763 6.22024 26.4829 6.0551 26.4891C5.1415 26.5235 4.5075 26.5474 4.5075 25.3905V12.2562ZM12.1971 12.256C12.1971 11.503 12.48 11.2228 12.9219 11.1352C13.2372 11.0728 14.101 11.0994 14.7629 11.1198H14.7629C15.029 11.128 15.2625 11.1352 15.4145 11.1352C15.9449 11.1352 16.157 11.9933 16.1393 12.6413C16.593 12.0381 17.1953 11.5604 17.8886 11.2538C18.5819 10.9472 19.343 10.8219 20.0992 10.89C20.8417 10.8451 21.5854 10.9554 22.2821 11.2137C22.9788 11.4721 23.6128 11.8728 24.143 12.3897C24.6732 12.9067 25.0876 13.5283 25.3595 14.2143C25.6313 14.9003 25.7544 15.6352 25.7207 16.3714V25.3378C25.7207 26.4936 25.1132 26.4708 24.198 26.4364C24.0316 26.4302 23.855 26.4236 23.6701 26.4236C23.4852 26.4236 23.3086 26.4302 23.1422 26.4364C22.227 26.4708 21.6195 26.4936 21.6195 25.3378V18.3328C21.6505 17.9723 21.6029 17.6094 21.4799 17.2687C21.3568 16.928 21.1612 16.6175 20.9063 16.3584C20.6514 16.0992 20.3432 15.8974 20.0026 15.7667C19.662 15.636 19.297 15.5795 18.9324 15.6009C18.5695 15.5918 18.2088 15.6591 17.8741 15.7985C17.5394 15.9378 17.2384 16.146 16.9911 16.4093C16.7437 16.6725 16.5556 16.9848 16.4393 17.3255C16.3229 17.6661 16.2809 18.0274 16.3161 18.3854V25.3903C16.3161 26.5465 15.6955 26.5233 14.7759 26.4889C14.609 26.4827 14.4324 26.4761 14.2478 26.4761C14.0629 26.4761 13.8863 26.4827 13.7199 26.489C12.8047 26.5233 12.1971 26.5462 12.1971 25.3903V12.256Z"
      fill="currentColor"
    />
  </svg>
);

const cross = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 1L1 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1 1L17 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const hamburgerMenu = (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" y="9.5" width="28" height="3" rx="1.5" fill="#1C1C1C" />
    <rect x="5" y="17.5" width="28" height="3" rx="1.5" fill="#1C1C1C" />
    <rect x="5" y="25.5" width="28" height="3" rx="1.5" fill="#1C1C1C" />
  </svg>
);

const chatBubble = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.80512 2.29688C11.9261 2.29688 13.9603 3.13996 15.4601 4.64065C16.9599 6.14134 17.8025 8.17672 17.8025 10.299C17.8074 11.8741 17.3422 13.4149 16.4664 14.7237L17.8025 18.3012L13.3051 17.4915C12.2236 18.0193 11.0369 18.296 9.83358 18.3011C8.63026 18.3062 7.44131 18.0395 6.35532 17.5209C5.26932 17.0023 4.31429 16.2452 3.56137 15.3059C2.80845 14.3667 2.27707 13.2695 2.0068 12.0963C1.73654 10.923 1.73438 9.70377 2.00046 8.52953C2.26655 7.35528 2.79403 6.25626 3.54361 5.31435C4.29318 4.37243 5.24552 3.61191 6.32966 3.08946C7.4138 2.567 8.6018 2.29608 9.80512 2.29688V2.29688Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const sendMessageArrow = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2504_4022)">
      <path
        d="M6.12867 10C6.12867 10 3.24611 15.8006 3.13579 16.0187C3.02546 16.2369 2.99981 16.2957 3 16.4434C3.00019 16.5911 3.0608 16.7327 3.1685 16.8371C3.2762 16.9415 3.42217 17.0001 3.5743 17C3.72642 16.9999 3.86291 16.9626 4.0241 16.8798C4.1853 16.7969 16.3588 11.0106 16.3588 11.0106C16.5514 10.9188 16.7136 10.7764 16.827 10.5995C16.9403 10.4227 17.0003 10.2184 17 10.01C16.9997 9.80165 16.9393 9.59748 16.8255 9.42071C16.7117 9.24395 16.5491 9.10168 16.3562 9.0101C16.3562 9.0101 4.30749 3.23534 4.06795 3.1085C3.82841 2.98167 3.75719 3.00103 3.60507 3.0011C3.45295 3.00117 3.30713 3.05991 3.19969 3.1644C3.09226 3.2689 3.03201 3.41058 3.0322 3.55828C3.03239 3.70598 3.0915 3.80928 3.16634 3.98542C3.24117 4.16156 6.12867 10 6.12867 10ZM6.12867 10H11"
        stroke="#1C1C1C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2504_4022">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

const chatEmoji = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="7.25" stroke="#1C1C1C" strokeWidth="1.5" />
    <circle cx="7.75" cy="7.75" r="0.75" fill="#1C1C1C" />
    <circle cx="12.25" cy="7.75" r="0.75" fill="#1C1C1C" />
    <path
      d="M6.5 12.5C6.5 12.5 7.8125 14.25 10 14.25C12.1875 14.25 13.5 12.5 13.5 12.5"
      stroke="#1C1C1C"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const chatAttachDocument = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3268 4.22513C13.3535 3.25829 11.7735 3.25829 10.8002 4.22513L5.45254 9.53743C3.84915 11.1302 3.84915 13.7106 5.45254 15.3034C7.05869 16.8989 9.66481 16.8989 11.271 15.3034L15.9714 10.634C16.2653 10.342 16.7402 10.3436 17.0321 10.6375C17.324 10.9313 17.3224 11.4062 17.0286 11.6981L12.3281 16.3675C10.137 18.5442 6.58652 18.5442 4.3954 16.3675C2.20153 14.1882 2.20153 10.6526 4.3954 8.47325L9.74306 3.16095C11.3013 1.61302 13.8257 1.61302 15.3839 3.16095C16.9449 4.71163 16.9449 7.22785 15.3839 8.77853L10.0959 14.0315C9.17056 14.9508 7.6723 14.9508 6.74694 14.0315C5.81882 13.1096 5.81882 11.6126 6.74694 10.6907L11.08 6.38628C11.3738 6.09436 11.8487 6.09593 12.1406 6.3898C12.4325 6.68366 12.431 7.15853 12.1371 7.45045L7.80408 11.7548C7.46644 12.0902 7.46644 12.632 7.80408 12.9674C8.14447 13.3055 8.6984 13.3055 9.03879 12.9674L14.3268 7.71435C15.2973 6.75026 15.2973 5.18922 14.3268 4.22513Z"
      fill="#1C1C1C"
    />
  </svg>
);

const chevronBack = (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 11L15 19L23 27"
      stroke="#1C1C1C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect width="52" height="52" rx="26" fill="#E5EBF2" />
    <path
      d="M33.9962 33.4615C33.9962 33.8696 33.8334 34.2609 33.5436 34.5494C33.2539 34.8379 32.8609 35 32.4511 35H19.5451C19.1353 35 18.7423 34.8379 18.4526 34.5494C18.1628 34.2609 18 33.8696 18 33.4615V18.5385C18 18.1304 18.1628 17.7391 18.4526 17.4506C18.7423 17.1621 19.1353 17 19.5451 17H29L33.9962 22.3846V33.4615Z"
      stroke="var(--color-primary-300)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 17V23H34"
      stroke="var(--color-primary-300)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 26V32M26 26L24 28M26 26L28 28"
      stroke="var(--color-primary-300)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const uploadIconDanger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <rect
      width="52"
      height="52"
      rx="26"
      fill="var(--color-danger)"
      fillOpacity="0.1"
    />
    <path
      d="M33.9962 33.4615C33.9962 33.8696 33.8334 34.2609 33.5436 34.5494C33.2539 34.8379 32.8609 35 32.4511 35H19.5451C19.1353 35 18.7423 34.8379 18.4526 34.5494C18.1628 34.2609 18 33.8696 18 33.4615V18.5385C18 18.1304 18.1628 17.7391 18.4526 17.4506C18.7423 17.1621 19.1353 17 19.5451 17H29L33.9962 22.3846V33.4615Z"
      stroke="var(--color-danger)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 17V23H34"
      stroke="var(--color-danger)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 26V32M26 26L24 28M26 26L28 28"
      stroke="var(--color-danger)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const checkmark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_2759_4971)">
      <path
        d="M5.5 8.5L7.5 10L10.5 6"
        stroke="var(--color-success)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8"
        cy="8"
        r="7"
        stroke="var(--color-success)"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_2759_4971">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const camera = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="white" />
    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#D0D5DD" />
    <path
      d="M6 13.25C6 12.1454 6.89543 11.25 8 11.25H10L11.7031 8.6953C11.8886 8.4171 12.2008 8.25 12.5352 8.25H17.4648C17.7992 8.25 18.1114 8.4171 18.2969 8.6953L20 11.25H22C23.1046 11.25 24 12.1454 24 13.25V19.75C24 20.8546 23.1046 21.75 22 21.75H8C6.89543 21.75 6 20.8546 6 19.75V13.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle
      cx="15"
      cy="15.75"
      r="2.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

const dots = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2935_11873)">
      <circle cx="10" cy="2" r="2" fill="currentColor" />
      <circle cx="10" cy="10" r="2" fill="currentColor" />
      <circle cx="10" cy="18" r="2" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2935_11873">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const lock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
  >
    <path
      d="M8 5.25V4.25C8 3.45435 7.68393 2.69129 7.12132 2.12868C6.55871 1.56607 5.79565 1.25 5 1.25C4.20435 1.25 3.44129 1.56607 2.87868 2.12868C2.31607 2.69129 2 3.45435 2 4.25V5.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect y="5.5" width="10" height="8" rx="1" fill="currentColor" />
  </svg>
);

const youtube = (
  <svg
    fill="currentColor"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 512 512"
  >
    <path
      d="M34.354,0.5h45.959l29.604,91.096h2.863L141.013,0.5h46.353l-53.107,133.338v94.589H88.641V138.08
		L34.354,0.5z M192.193,98.657c0-13.374,5.495-24.003,16.493-31.938c10.984-7.934,25.749-11.901,44.3-11.901
		c16.893,0,30.728,4.192,41.506,12.55c10.805,8.358,16.193,19.112,16.193,32.287v89.2c0,14.771-5.301,26.373-15.868,34.782
		c-10.579,8.408-25.151,12.625-43.684,12.625c-17.859,0-32.143-4.342-42.866-13.024c-10.709-8.683-16.074-20.36-16.074-35.057
		V98.657z M234.205,191.424c0,4.766,1.44,8.409,4.354,11.029c2.907,2.595,7.055,3.867,12.451,3.867c5.532,0,9.93-1.297,13.18-3.942
		c3.256-2.669,4.891-6.313,4.891-10.954V97.359c0-3.768-1.672-6.812-4.99-9.132c-3.318-2.321-7.679-3.494-13.081-3.494
		c-4.972,0-9.027,1.173-12.133,3.494c-3.119,2.32-4.672,5.364-4.672,9.132V191.424z M459.992,57.588v172.711h-40.883v-19.063
		c-7.547,7.037-15.381,12.375-23.541,16.069c-8.146,3.643-16.068,5.489-23.729,5.489c-9.455,0-16.592-2.57-21.383-7.71
		c-4.791-5.141-7.186-12.85-7.186-23.13V57.588h40.895v132.39c0,4.117,0.861,7.061,2.57,8.907c1.723,1.822,4.492,2.745,8.322,2.745
		c3.018,0,6.824-1.223,11.4-3.643c4.604-2.42,8.82-5.514,12.65-9.282V57.588H459.992z M421.68,363.262
		c-2.008-2.221-5.203-3.368-9.594-3.368c-4.59,0-7.883,1.147-9.879,3.368c-1.996,2.245-2.994,5.963-2.994,11.153v10.754h25.473
		v-10.754C424.686,369.225,423.688,365.507,421.68,363.262z M300.855,444.228c2.195,0.898,4.516,1.322,6.961,1.322
		c3.543,0,6.113-0.849,7.785-2.595c1.67-1.722,2.494-4.591,2.494-8.533v-62.178c0-4.191-1.023-7.36-3.068-9.531
		c-2.059-2.171-5.064-3.244-8.957-3.244c-2.059,0-4.092,0.399-6.102,1.198c-2.008,0.823-3.991,2.096-5.95,3.792v75.402
		C296.364,441.907,298.646,443.354,300.855,444.228z M490.496,312.587c0-29.941-30.754-54.219-68.654-54.219
		c-54.068-1.822-109.396-2.62-165.842-2.521c-56.427-0.1-111.756,0.698-165.843,2.521c-37.881,0-68.633,24.277-68.633,54.219
		c-2.277,23.678-3.263,47.381-3.175,71.085c-0.087,23.703,0.898,47.406,3.175,71.11c0,29.916,30.752,54.192,68.633,54.192
		c54.087,1.797,109.416,2.596,165.843,2.521c56.446,0.075,111.774-0.724,165.842-2.521c37.9,0,68.654-24.276,68.654-54.192
		c2.27-23.704,3.254-47.407,3.154-71.11C493.75,359.968,492.766,336.265,490.496,312.587z M121.251,463.465v1.797H88.778v-1.797
		V321.644H55.182v-1.771v-22.605v-1.771h99.672v1.771v22.605v1.771h-33.603V463.465z M236.768,341.33v122.135v1.797h-28.831v-1.797
		v-11.901c-5.327,5.064-10.848,8.882-16.592,11.527c-5.757,2.619-11.334,3.942-16.748,3.942c-6.662,0-11.684-1.847-15.065-5.515
		c-3.387-3.692-5.078-9.231-5.078-16.617v-1.797V341.33v-1.772h28.844v1.772v93.216c0,2.92,0.599,5.065,1.802,6.363
		c1.217,1.322,3.175,1.971,5.876,1.971c2.127,0,4.803-0.873,8.047-2.595c3.231-1.747,6.2-3.967,8.914-6.662V341.33v-1.772h28.831
		V341.33z M347.775,370.847v66.943v1.797c0,8.808-2.258,15.544-6.773,20.235c-4.518,4.641-11.055,6.986-19.588,6.986
		c-5.639,0-10.652-0.898-15.07-2.695c-4.428-1.821-8.532-4.616-12.325-8.384v7.735v1.797h-29.105v-1.797V297.267v-1.771h29.105
		v1.771v52.297c3.893-3.793,8.009-6.662,12.376-8.608c4.379-1.971,8.809-2.969,13.273-2.969c9.107,0,16.094,2.645,20.896,7.935
		c4.803,5.289,7.211,12.999,7.211,23.13V370.847z M454.365,374.64v29.767v1.797h-55.152v21.581c0,6.513,0.947,11.029,2.844,13.549
		c1.908,2.521,5.152,3.793,9.742,3.793c4.779,0,8.135-1.073,10.043-3.219c1.896-2.121,2.844-6.837,2.844-14.123v-6.811v-1.796h29.68
		v1.796v7.51v1.796c0,12.7-3.605,22.257-10.84,28.694c-7.225,6.438-18.016,9.631-32.375,9.631c-12.912,0-23.066-3.418-30.49-10.229
		c-7.41-6.812-11.127-16.193-11.127-28.096v-1.796V374.64v-1.771c0-10.754,4.078-19.512,12.213-26.299
		c8.146-6.762,18.689-10.155,31.588-10.155c13.199,0,23.328,3.144,30.416,9.406c7.061,6.264,10.615,15.296,10.615,27.048V374.64z"
    ></path>
  </svg>
);

const instagram = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      fill="currentColor"
    />
    <path
      d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z"
      fill="currentColor"
    />
  </svg>
);

const externalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="Interface / External_Link">
      <path
        id="Vector"
        d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const shieldCheck = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="16px"
    height="16px"
    viewBox="0 0 36 36"
    version="1.1"
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <title>shield-check-line</title>{' '}
      <path d="M31.25,7.4a43.79,43.79,0,0,1-6.62-2.35,45,45,0,0,1-6.08-3.21L18,1.5l-.54.35a45,45,0,0,1-6.08,3.21A43.79,43.79,0,0,1,4.75,7.4L4,7.59v8.34c0,13.39,13.53,18.4,13.66,18.45l.34.12.34-.12c.14,0,13.66-5.05,13.66-18.45V7.59ZM30,15.93c0,11-10,15.61-12,16.43-2-.82-12-5.44-12-16.43V9.14a47.54,47.54,0,0,0,6.18-2.25,48.23,48.23,0,0,0,5.82-3,48.23,48.23,0,0,0,5.82,3A47.54,47.54,0,0,0,30,9.14Z" />
      <path d="M10.88,16.87a1,1,0,0,0-1.41,1.41l6,6L26.4,13.77A1,1,0,0,0,25,12.33l-9.47,9.19Z" />{' '}
      <rect x="0" y="0" width="36" height="36" fillOpacity="0" />{' '}
    </g>
  </svg>
);

const resendEmail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.53846 13.4615H2.38462C2.01739 13.4615 1.66521 13.3157 1.40554 13.056C1.14588 12.7963 1 12.4441 1 12.0769V2.38462C1 2.01739 1.14588 1.66521 1.40554 1.40554C1.66521 1.14588 2.01739 1 2.38462 1H16.2308C16.598 1 16.9502 1.14588 17.2098 1.40554C17.4695 1.66521 17.6154 2.01739 17.6154 2.38462V7.23077"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 2.74463L9.30769 8.6154L17.6154 2.74463"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8796 15.5385C18.4108 17.5231 16.6279 19 14.5 19C12.0147 19 10 16.9853 10 14.5C10 12.0147 12.0147 10 14.5 10C16.2361 10 17.7426 10.9832 18.4931 12.4231"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19 10.5L19 12.7692H16.7648"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export {
  plus,
  plusRounded,
  plusInCircle,
  minus,
  eyeShow,
  eyeHide,
  search,
  searchSpinner,
  trash,
  trashCurrentColor,
  chat,
  file,
  pdf,
  doc,
  spinner,
  pageSpinner,
  success,
  danger,
  trashDisabled,
  info,
  chevronUp,
  chevronDown,
  address,
  phone,
  email,
  pencil,
  facebook,
  twitter,
  linkedin,
  loadingSpinner,
  cross,
  hamburgerMenu,
  arrowLeft,
  logOut,
  chatBubble,
  chatEmoji,
  chatAttachDocument,
  sendMessageArrow,
  chevronBack,
  infoNoOutline,
  present,
  bell,
  uploadIcon,
  uploadIconDanger,
  checkmark,
  camera,
  dots,
  lock,
  youtube,
  instagram,
  externalLink,
  shieldCheck,
  resendEmail,
};
